import { useState } from "react";
import { Chip, TextField } from "@mui/material";
import TransferList from "../../../components/TransferList"; // Adjust the path based on your actual file structure
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useGetUsersRelated from "../../../hooks/store/useGetUsersRelated";
import Grid from "@mui/material/Unstable_Grid2";
import { ManageAccountsOutlined } from "@mui/icons-material";
function UserStoreRegisterPage() {
  const params = useParams();
  const { choices, chosen, isLoading } = useGetUsersRelated(params.id || "");
  const [filtro, setFiltro] = useState("");
  const [choiceFilter, setChoiceFilter] = useState<any>();
  useEffect(() => {
    setChoiceFilter(choices);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  const dadosFiltrados = choiceFilter?.filter((item: any) =>
    item?.name?.toLowerCase().includes(filtro.toLowerCase())
  );

  const handleFiltroChange = (e: any) => {
    setFiltro(e.target.value);
  };
  return (
    <Grid container spacing={2}>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <Chip
          icon={<ManageAccountsOutlined color="warning" />}
          label={"Adicionar Utilizador a Loja"}
        />
      </Grid>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <TextField
          label="Pesquisar por nome"
          variant="filled"
          fullWidth
          value={filtro}
          onChange={handleFiltroChange}
        />
      </Grid>

      <Grid xs={12} md={12} lg={12} xl={12}>
        <TransferList
          chosen={chosen}
          choices={dadosFiltrados}
          id={parseInt(params.id || "")}
        />
      </Grid>
    </Grid>
  );
}

export default UserStoreRegisterPage;
